// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explore .homeContainerExplore {
    padding-top: 3rem;
    text-align: center;
    width: 100%;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }


.explore .complexView {
    background-color: #282B30;

    height: 170px;
    padding: 10px;
    position: relative;
    
}
.explore .addNew{
    display: grid;
    grid-template: 1fr / 1fr;
    place-items: center;
}
.explore .iconHolder{
   
    z-index: 2;
  
}
.explore .newComplex{
    z-index: 1;


}
.explore .css-i4bv87-MuiSvgIcon-root{
    font-size: 50px !important;
}
.explore .newComplexView {
    background-color: #282B30;

    height: 170px;
    padding: 10px;
    position: relative;
    color: #BBBCBD;

}

.explore .newComplexView button {
    width: 100%;
    height: 100%;
    color: #BBBCBD;
}
.explore .newComplexView button:hover {
    background-color: #131416;
}


.explore .started {
    text-align: left;
    color: white;
}

.explore .wrapper {
    display: flex;
}

.explore .mainButton Button {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);

}

.explore .mainButton Button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}


.explore .complexButton {
    text-align: left !important;
    color: white;
    max-height: 50px;
    overflow: hidden;
}

.explore .complexButton button {
    border-radius: 0 !important;
    text-align: left !important;
    color: #fff;
    width: 100%;
    margin: 0;
}

.explore .complexButton button:hover {
    background-color: #1d1f22 !important;

}

.explore .complexButton button h2 {
    width: 100%;
    text-align: left !important;
    margin: 0;
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore .Info {
    text-align: left;
    color: #BBBCBD;
    padding: 10px;
    font-size: 16px;
    max-height: 60px;
    overflow: hidden;
}

.explore .switchHolder {
    position: absolute;
    bottom: 0px;
    display: flex;
}

.explore .switches {
    position: relative;
    bottom: 0px;
    display: flex;
}

.explore .leftSwitch {
    display: flex;
    color: #BBBCBD;
    font-size: 13px;
    align-items: center;
}

.explore .rightSwitch {
    right: 0 !important;
    font-size: 13px;
    display: flex;
    color: #BBBCBD;
    align-items: center;
}

.explore .masa {
    width: 100%;
    font-size: 30px;
}

.deleteIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.deleteIcon .css-i4bv87-MuiSvgIcon-root {
    font-size: x-large !important;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/ExploreSites/ExploreSites.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;;AAGF;IACI,yBAAyB;;IAEzB,aAAa;IACb,aAAa;IACb,kBAAkB;;AAEtB;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,mBAAmB;AACvB;AACA;;IAEI,UAAU;;AAEd;AACA;IACI,UAAU;;;AAGd;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;;IAEzB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iFAAiF;;AAErF;;AAEA;IACI,iFAAiF;AACrF;;;AAGA;IACI,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":[".explore .homeContainerExplore {\n    padding-top: 3rem;\n    text-align: center;\n    width: 100%;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n\n.explore .complexView {\n    background-color: #282B30;\n\n    height: 170px;\n    padding: 10px;\n    position: relative;\n    \n}\n.explore .addNew{\n    display: grid;\n    grid-template: 1fr / 1fr;\n    place-items: center;\n}\n.explore .iconHolder{\n   \n    z-index: 2;\n  \n}\n.explore .newComplex{\n    z-index: 1;\n\n\n}\n.explore .css-i4bv87-MuiSvgIcon-root{\n    font-size: 50px !important;\n}\n.explore .newComplexView {\n    background-color: #282B30;\n\n    height: 170px;\n    padding: 10px;\n    position: relative;\n    color: #BBBCBD;\n\n}\n\n.explore .newComplexView button {\n    width: 100%;\n    height: 100%;\n    color: #BBBCBD;\n}\n.explore .newComplexView button:hover {\n    background-color: #131416;\n}\n\n\n.explore .started {\n    text-align: left;\n    color: white;\n}\n\n.explore .wrapper {\n    display: flex;\n}\n\n.explore .mainButton Button {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n\n}\n\n.explore .mainButton Button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n\n.explore .complexButton {\n    text-align: left !important;\n    color: white;\n    max-height: 50px;\n    overflow: hidden;\n}\n\n.explore .complexButton button {\n    border-radius: 0 !important;\n    text-align: left !important;\n    color: #fff;\n    width: 100%;\n    margin: 0;\n}\n\n.explore .complexButton button:hover {\n    background-color: #1d1f22 !important;\n\n}\n\n.explore .complexButton button h2 {\n    width: 100%;\n    text-align: left !important;\n    margin: 0;\n    white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.explore .Info {\n    text-align: left;\n    color: #BBBCBD;\n    padding: 10px;\n    font-size: 16px;\n    max-height: 60px;\n    overflow: hidden;\n}\n\n.explore .switchHolder {\n    position: absolute;\n    bottom: 0px;\n    display: flex;\n}\n\n.explore .switches {\n    position: relative;\n    bottom: 0px;\n    display: flex;\n}\n\n.explore .leftSwitch {\n    display: flex;\n    color: #BBBCBD;\n    font-size: 13px;\n    align-items: center;\n}\n\n.explore .rightSwitch {\n    right: 0 !important;\n    font-size: 13px;\n    display: flex;\n    color: #BBBCBD;\n    align-items: center;\n}\n\n.explore .masa {\n    width: 100%;\n    font-size: 30px;\n}\n\n.deleteIcon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.deleteIcon .css-i4bv87-MuiSvgIcon-root {\n    font-size: x-large !important;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
